const adminToolsWidget = {
  popoverBody: () => null,
  isActive: ({ permissions, roles }) => {
    // later we might want to add , 'Surveys', 'dashboard', 'Analytics' to admin scopes @roman.horokhov
    const ADMIN_SCOPES = ['PLATFORM_ADMIN', 'RULES_ENGINE', 'DM'];

    if (roles) {
      const isSuperAdmin = roles.some(
        (role) => role.roleType === 'SUPER_ADMIN',
      );

      if (isSuperAdmin) return true;
    }

    if (permissions) {
      const hasPermission = permissions.some((permission) =>
        ADMIN_SCOPES.includes(permission.scope),
      );

      if (hasPermission) return hasPermission;
    }

    return false;
  },
  onClickHandler: () => {
    // eslint-disable-next-line no-undef
    window.location = `${window.location.origin}/apps/home/#/admin`;

    return null;
  },
};

export default adminToolsWidget;
